import getElementMap from "../../assets/elements/__elementMap";
import getDevPartialMap from "../../assets/devPartials";
import { divideDefsitesByOrigin } from "../divideDefsitesByOrigin";
import releaseSettings from "../../config/releaseSettings";
import InternalBuildTemplateManager from "./helpers/DebugTemplateManager";
import ReleaseTemplateManager from "./helpers/ReleaseTemplateManager";
import { changeTemplateSettings } from '../../assets/creator/template';

//this function gets IDs only, probably gonna change it when figuring out importing xml
function getCreatorSiteElementIDs(creatorSiteBodyContent) {
    const IDs = [];
    creatorSiteBodyContent.forEach(element => {
        IDs.push({
            type: element.type,
            id: element.id,
            name: element.name,
            folder: element.folder,
            file: element.file
        });
    });
    return IDs;
}

function generateCreatorSiteLiquidIncludes(IDs, shouldAddBreadCrumbs, site) {
    if(site.listName === 'mainBody') {
        return generateCreatorSiteForMainPage(IDs);
    } else {
        return generateCreatorSite(IDs, shouldAddBreadCrumbs, site);
    }
}

function generateCreatorSiteForMainPage(IDs) {
    let output = ''; 

    let i = 0;
    let IdsLast = IDs.length;
    let bannerCounter = 0;
    let promotionalBannerCounter = 0;
    let newsSectionCounter = 0;
    let textElementCounter = 0;

    IDs.forEach(element => {
        let includeWithName = "";
        if (element.name) {
            includeWithName = `with '${element.name}' `;
        }
        let settingsType = '';


        if (element.type !== 'widget' && element.type !== 'popupBanner' && element.id !== 'newsletterPopup-1') {
            i += 1;
        }

        switch(element.type) {
            case 'mainBanner':
                bannerCounter = bannerCounter + 1;
                changeTemplateSettings("bodyMainBannerSet", "on");
                changeTemplateSettings("bodyMainBanner_" + bannerCounter, "on");
                changeTemplateSettings("bodyMainBannerNo_" + bannerCounter, i);
                changeTemplateSettings("bodyMainBannerCounter", bannerCounter);
                changeTemplateSettings("bodyMainBannerBannerName_" + bannerCounter, element.name);
            break;

            case 'widget':
                changeTemplateSettings("bodyWidget", "on");
                changeTemplateSettings("bodyWidgetNo", IdsLast);
                changeTemplateSettings("bodyWidgetSet", "on");
                settingsType = 'bodyWidget';
                IdsLast -= 1;
            break;

            case 'popupBanner':
                changeTemplateSettings("bodyPopupBanner", "on");
                changeTemplateSettings("bodyPopupBannerNo", IdsLast);
                changeTemplateSettings("bodyPopupBannerSet", "on");
                settingsType = 'bodyPopupBanner';
                IdsLast -= 1;
            break;

            case 'newsSection':
                newsSectionCounter = newsSectionCounter + 1;
                changeTemplateSettings("bodyRecommendedSet", "on");
                changeTemplateSettings("bodyRecommended_" + newsSectionCounter, "on");
                changeTemplateSettings("bodyRecommendedNo_" + newsSectionCounter, i);
                changeTemplateSettings("bodyRecommendedCounter", newsSectionCounter);
                changeTemplateSettings("bodyRecommendedTranslation_" + newsSectionCounter, element.name.replaceAll('-', '_'));
            break;

            case 'newsletter':
                if (element.id.includes("Popup")) {
                    changeTemplateSettings("bodyPopupNewsletter", "on");
                    changeTemplateSettings("bodyPopupNewsletterNo", IdsLast);
                    changeTemplateSettings("bodyPopupNewsletterSet", "on");
                    settingsType = 'bodyPopupNewsletter';
                    IdsLast -= 1;
                } else {
                    changeTemplateSettings("bodyNewsletter", "on");
                    changeTemplateSettings("bodyNewsletterNo", i);
                    changeTemplateSettings("bodyNewsletterSet", "on");
                    settingsType = 'bodyNewsletter';
                }
            break;

            case 'manufacturersSlider':
                changeTemplateSettings("bodyManufacturersSlider", "on");
                changeTemplateSettings("bodyManufacturersSliderNo", i);
                changeTemplateSettings("bodyManufacturersSliderSet", "on");
                settingsType = 'bodyManufacturersSlider';
            break;

            case 'brandsSlider':
                changeTemplateSettings("bodyBrandsSlider", "on");
                changeTemplateSettings("bodyBrandsSliderNo", i);
                changeTemplateSettings("bodyBrandsSliderSet", "on");
                settingsType = 'bodyBrandsSlider';
            break; 

            case 'news':
                changeTemplateSettings("bodyBlog", "on");
                changeTemplateSettings("bodyBlogNo", i);
                changeTemplateSettings("bodyBlogSet", "on");
                settingsType = 'bodyBlog';
            break;

            case 'infographicBanner':
                changeTemplateSettings("bodyInfographicBanner", "on");
                changeTemplateSettings("bodyInfographicBannerNo", i);
                changeTemplateSettings("bodyInfographicBannerSet", "on");
                settingsType = 'bodyInfographicBanner';
            break;

            case 'textElement':
                textElementCounter = textElementCounter + 1;
                changeTemplateSettings("bodyTextElementSet", "on");
                changeTemplateSettings("bodyTextElement_" + textElementCounter, "on");
                changeTemplateSettings("bodyTextElementNo_" + textElementCounter, i);
                changeTemplateSettings("bodyTextElementCounter", textElementCounter);
                settingsType = 'bodyTextElement';
            break; 

            case 'promotionalBanner': 
                promotionalBannerCounter = promotionalBannerCounter + 1;
                changeTemplateSettings("bodyPromotionalBannerSet", "on");
                changeTemplateSettings("bodyPromotionalBanner_" + promotionalBannerCounter, "on");
                changeTemplateSettings("bodyPromotionalBannerNo_" + promotionalBannerCounter, i);
                changeTemplateSettings("bodyPromotionalBannerCounter", promotionalBannerCounter);
                changeTemplateSettings("bodyPromotionalBannerName_" + promotionalBannerCounter, element.id + '-' + promotionalBannerCounter);
            break;

            default:
                settingsType = 'noSettings';
            break;
        }

        if (element.type === 'mainBanner') {
            const include = ` {% if settings.bodyMainBanner_`+ bannerCounter + ` == "on" -%}
            <div style="order:{{settings.bodyMainBannerNo_` + bannerCounter + `}}">
                {% include 'elements/${element.type}/${element.id}.html' ${includeWithName}-%}
            </div>
            {% endif -%}\n\n`;

            output = output.concat(include);
        }
        else if (element.type === 'newsSection') {
            const include = ` {% if settings.bodyRecommended_`+ newsSectionCounter + ` == "on" -%}
            <div style="order:{{settings.bodyRecommendedNo_` + newsSectionCounter + `}}">
                {% include 'elements/${element.type}/${element.id}.html' ${includeWithName}-%}
            </div>
            {% endif -%}\n\n`;

            output = output.concat(include);
        } else if (element.type === 'textElement') {
            const include = ` {% if settings.bodyTextElement_`+ textElementCounter + ` == "on" -%}
            <div style="order:{{settings.bodyTextElementNo_` + textElementCounter + `}}">
                {% include 'elements/${element.type}/${element.id}.html' ${includeWithName}-%}
            </div>
            {% endif -%}\n\n`;

            output = output.concat(include);
            i += 1;
        } else if (element.type === 'promotionalBanner') {
            const include = ` {% if settings.bodyPromotionalBanner_`+ promotionalBannerCounter + ` == "on" -%}
            <div style="order:{{settings.bodyPromotionalBannerNo_` + promotionalBannerCounter + `}}">
                {% include 'elements/${element.type}/${element.id}.html' ${includeWithName} bannerName: 'bodyPromotionalBannerName_${promotionalBannerCounter}'-%}
            </div>
            {% endif -%}\n\n`;

            output = output.concat(include);
            i += 1;
        } else {
            const include = ` {% if settings.` + settingsType + ` == "on" -%}
                <div style="order:{{settings.` + settingsType + `No}}">
                    {% include 'elements/${element.type}/${element.id}.html' ${includeWithName}-%}
                </div>
            {% endif -%}\n\n`;

            output = output.concat(include);
        }
    });
    
    if (textElementCounter === 0) {
        changeTemplateSettings("bodyTextElementSet", "off");
        changeTemplateSettings("bodyTextElementCounter", 0); 
    }

    if (promotionalBannerCounter === 0) {
        changeTemplateSettings("bodyPromotionalBannerSet", "off");
        changeTemplateSettings("bodyPromotionalBannerCounter", 0);
    }

    return output;
}

function generateCreatorSite(IDs, shouldAddBreadCrumbs, site) {
    let output = "";
    if (shouldAddBreadCrumbs) {
        output = "{% include 'partials/common/breadcrumbs.html' -%}\n";
    }
    IDs.forEach(element => {
        let includeWithName = "";
        if (element.name) {
            includeWithName = `with '${element.name}' `;
        }
        let elementHtml = null;
        let include = null;

        try {
            let folder;
            if (element.folder) {
                folder = element.folder;
            } else {
                folder = element.type + 's';
            }
            
            let file;
            if (element.file) {
                file = element.file;
            } else {
                file = element.id;
            }
            
            elementHtml = require(`../../assets/elements/${folder}/${file}/html.js`);
        } catch (e) {
            console.log(e)
        }

        if (elementHtml) {
            include = `{% include 'elements/${element.type}/${element.id}.html' ${includeWithName}-%}\n`;
            output = output.concat(include);
        }
    });
    if (!output) {
        const staticInclude = `{% include 'static-elements/${site.name.slice(0,-5)}/${site.name}' -%}\n`;
        output = staticInclude;
    }
    return output;
}
/**
 * 
 * @param {TemplateManager} templateManager 
 * @param {[]} creatorPages 
 */
function getPagesFromCreator(templateManager, creatorPages) {
    const returnArray = [];
    creatorPages.forEach(site => {
        const creatorSiteBodyContent = this.state[site.listName];
        const IDs = getCreatorSiteElementIDs(creatorSiteBodyContent);
        const liquidIncludes = generateCreatorSiteLiquidIncludes(IDs, site.shouldAddBreadCrumbs, site);
        if(site.listName==='mainBody') {
            templateManager.generateLayoutExtensionTemplate(liquidIncludes, site.name, true, {
                top: `<div class="homepage">\n`,
                bottom: `</div>\n{% include 'partials/rich-snippets/corporate-contacts.html' -%}\n`
            });
        } 
        else if (site.listName==='productListBody'){
            templateManager.generateLayoutExtensionTemplate(liquidIncludes, site.name, true, {
                top:`
                    {% assign whatPrice = translations.Brutto | Downcase -%}

                    {% if customer.Cart.SubtotalPrices -%}
                        {% assign whatPrice = translations.Netto | Downcase -%}
                    {% endif -%}

                    {% assign view = 'quick-shopping' -%}

                    {% if settings.selectedViewName -%}
                        {% assign view = settings.selectedViewName -%}
                    {% endif -%}

                    {% if page.Cookies.selectedViewName -%}
                        {% assign view = page.Cookies.selectedViewName -%}
                    {% endif -%}

                    <div class="products-page products-page-js">\n`,

                bottom:`
                    </div>\n
                    <div class="during-ajax-modal-js during-ajax-modal hidden-js">
                        <div class="loader big"></div>
                    </div>\n`
            });
        }
        else if (site.listName==='cartBody'){

            const cartId = IDs.find(element => element.type === 'cart').id;
            changeTemplateSettings("cartId", cartId);

            templateManager.generateLayoutExtensionTemplate(liquidIncludes, site.name, true);
        }
        else {
            templateManager.generateLayoutExtensionTemplate(liquidIncludes, site.name, true);
        }
        generateCreatorSiteObjectTemplates(templateManager, IDs);
    });
    return returnArray;
}
/**
 * 
 * @param {Array} staticSites 
 */
function buildStaticPageRouteSet(staticSites) {
    const routeSet = new Map();
    staticSites.forEach(site => {
        const siteName = site.name.split(".")[0];
        if (routeSet.has(siteName)) {
            return;
        }
        routeSet.set(siteName, {
            shouldAddBreadCrumbs: site.shouldAddBreadCrumbs,
            isExtends: site.isExtends
        });
    });
    return routeSet;
}
/**
 * 
 * @param {TemplateManager} templateManager
 * @param {Array} staticSites 
 */
function getStaticPages(
    templateManager,
    staticSites
) {
    const returnArray = [];
    const routeSet = buildStaticPageRouteSet(staticSites);
    routeSet.forEach((properties, name) => {
        let includeString = "";
        if (properties.shouldAddBreadCrumbs) {
            includeString = "{% include 'partials/common/breadcrumbs.html' -%}\n";
        }
        includeString += `{% include 'static-elements/${name}/${name}.html' -%}\n`;
        const layoutExtensionName = name + ".html";
        generateStaticSiteObjectTemplate(templateManager, name);
        templateManager.generateLayoutExtensionTemplate(includeString, layoutExtensionName, properties.isExtends !== undefined, null);
    })
    return returnArray;
}

/**
 * 
 * @param {TemplateManager} templateManager 
 * @param {string}
 */
function generateStaticSiteObjectTemplate(
    templateManager,
    name
) {
    const templateObject = require(`../../assets/static-elements/${name}`).default[0];
    templateManager.generateObjectTemplate("static-elements", name, templateObject);
}
/**
 * 
 * @param {TemplateManager} templateManager 
 * @param {Array} IDs 
 */
function generateCreatorSiteObjectTemplates(
    templateManager,
    IDs
) {
    const prefix = "elements";
    //iterate over elements in creator site body
    IDs.forEach(ID => {
        if (!ID.type || !ID.id) {
            throw new Error("Element type or id not specified");
        }
        const path = ID.type;

        const templateObject = getElementMap().get(`${ID.type}/${ID.id}`);
        if (!templateObject) {
            return;
        }
        if (templateObject.html) {
            templateManager.generateObjectTemplate(prefix, path, templateObject);
        }
    });
}

/**
 * 
 * @param {TemplateManager} templateManager 
 */
function getGlobalCreatorElements(templateManager) {
    const globalElements = require("../../assets/elements.json").globalTypes;
    const IDs = [];
    globalElements.forEach(element => {
        //assuming that global types have only one element
        const creatorTemplateObject = this.state[element][0];
        const ID = {
            id: creatorTemplateObject.id,
            type: creatorTemplateObject.type,
            name: creatorTemplateObject.name
        }
        IDs.push(ID);
    });
    generateCreatorSiteObjectTemplates(templateManager, IDs);
}
/**
 * 
 * @param {TemplateManager} templateManager 
 */
function getDevPartials(templateManager) {
    const map = getDevPartialMap();
    for (const kv of map.entries()) {
        const path = kv[0].substring(9);
        const obj = kv[1];
        templateManager.generateObjectTemplate('partials', path, obj);
    }
}
/**
 * 
 * @param {TemplateManager} templateManager 
 */
function getPartials(templateManager) {
    const partialsMap = require("../../assets/partials").default;
    for (const kv of partialsMap.entries()) {
        const path = kv[0].substring(9);
        const obj = kv[1];
        templateManager.generateObjectTemplate('partials', path, obj);
    }
}

//creates liquid pages
function getTemplates() {
    let templateManager;
    if (releaseSettings.internalBuild) {
        templateManager = new InternalBuildTemplateManager();
    } else {
        templateManager = new ReleaseTemplateManager();
    }
    const fontFamily = this.state.colorSettings.fontFamily || "Roboto";
    const spinner = {
        style: this.state.colorSettings.iconStyle,
        icon: this.state.colorSettings.spinnerIconStyle
    }
    const dividedDefsites = divideDefsitesByOrigin();
    getDevPartials(templateManager);
    getPartials(templateManager);
    getStaticPages(templateManager, dividedDefsites.staticSites);
    getPagesFromCreator.call(this, templateManager, dividedDefsites.creatorPages);
    templateManager.getBaseLayout();

    getGlobalCreatorElements.call(this, templateManager);

    const templates = templateManager.getTemplates(spinner, fontFamily);
    return { Template: templates };
}

export default getTemplates;